// feature types
import { parseNumber, parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'
import { RolodexEntryJson } from './rolodexEntryFields'

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- this is the actual type
const isNullOrUndefined = (value: any) => {
  return value === null || value === undefined
}

export class GeckoSiteConfig extends GeckoEntryBase<
  {
    budget: number
    chartTimeframe: number
    site_level_criticality_mapping?: Record<string, string>
    yearlyBudgets: Record<string, number>
  },
  {
    site: string
    organization: string
  }
> {
  /**
   * A simple constructor, private so that a more descriptive factory method
   * (which can return undefined) is used instead
   * @param json The raw JSON to create an instance from
   * @private
   */
  private constructor(json: RolodexEntryJson) {
    super(
      json,
      {
        budget: parseNumber(json.data.budget) ?? 0,
        chartTimeframe: parseNumber(json.data.chart_timeframe) ?? 0,
        site_level_criticality_mapping: isNullOrUndefined(
          json.data.site_level_criticality_mapping
        )
          ? {
              '1': '1',
              '2': '2',
              '3': '3',
              '4': '4',
              '5': '5',
            }
          : (json.data.site_level_criticality_mapping as Record<
              string,
              string
            >),
        yearlyBudgets: isNullOrUndefined(json.data.yearly_budgets)
          ? {}
          : (json.data.yearly_budgets as Record<string, number>),
      },
      {
        organization: parseString(json.tags.organization) ?? '',
        site: parseString(json.tags.site) ?? '',
      },
      {}
    )
  }

  /**
   * A simple factory method which creates a report from raw JSON
   * @param json The raw JSON to create an instance from
   * @constructor
   */
  public static CreateFromJSON(json: RolodexEntryJson) {
    return new GeckoSiteConfig(json)
  }
}
